import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Button, Paper, Typography } from "@mui/material";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import {
  ContentDialog,
  ContentDialogInit,
} from "../../../../components/MDDForm/components/ContentDialog.jsx";

const METHODS = [
  {
    key: "manual",
    icon: GroupAddIcon,
    label: "Manuell auswählen",
    description:
      "Objekte einzeln aus der Liste der Kundenobjekte anhaken und zuordnen.",
  },
  {
    key: "excel",
    icon: UploadFileIcon,
    label: "Per Excel-Datei",
    description:
      "Eine Excel-Datei mit Adressdaten hochladen und die Zuordnung automatisch abgleichen.",
  },
];

/**
 * Vorschaltdialog für "Objekte zuweisen": lässt den Nutzer zwischen manueller
 * Mehrauswahl (BulkAssignObjectsDialog) und Excel-Import (BankAccountObjectImportDialog)
 * wählen, bevor die eigentliche Funktion geöffnet wird.
 */
function AssignObjectsChoiceDialog({ open, onClose, onContinue }) {
  const [selectedMethod, setSelectedMethod] = useState(null);
  const { openCD, setOpenCD, tca, setTca } = ContentDialogInit();

  useEffect(() => {
    if (!open) {
      setOpenCD(false);
      return;
    }
    setSelectedMethod(null);
    setOpenCD(true);
    // eslint-disable-next-line
  }, [open]);

  useEffect(() => {
    setTca({
      title: "Objekte zuweisen",
      maxWidth: "sm",
      content: (
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Wie möchten Sie die Objekte diesem Bankkonto zuordnen?
          </Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            {METHODS.map(({ key, icon: Icon, label, description }) => (
              <Paper
                key={key}
                onClick={() => setSelectedMethod(key)}
                elevation={selectedMethod === key ? 4 : 1}
                sx={{
                  flex: 1,
                  p: 2,
                  cursor: "pointer",
                  border: 1,
                  borderColor:
                    selectedMethod === key ? "primary.main" : "grey.300",
                  transition: "border-color 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    borderColor: "primary.light",
                    boxShadow: 3,
                  },
                }}
              >
                <Icon color={selectedMethod === key ? "primary" : "action"} />
                <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
                  {label}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {description}
                </Typography>
              </Paper>
            ))}
          </Box>
        </Box>
      ),
      actions: (
        <>
          <Button onClick={onClose}>Abbrechen</Button>
          <Button
            variant="contained"
            disabled={!selectedMethod}
            onClick={() => onContinue(selectedMethod)}
          >
            Weiter
          </Button>
        </>
      ),
    });
    // eslint-disable-next-line
  }, [selectedMethod]);

  return (
    <ContentDialog openCD={openCD} setOpenCD={setOpenCD} tca={tca} onClose={onClose} />
  );
}

AssignObjectsChoiceDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};

export default AssignObjectsChoiceDialog;
